import { OrganizationKeyName } from "../../../model/Organization";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { httpProductTags } from "./product-tags-http";

export const productTagsCacheKeys = {
  productTags: "productTags",
};

export const useListProductTags = (
  organizationKeyName: OrganizationKeyName
) => {
  return useQuery(
    [productTagsCacheKeys.productTags, organizationKeyName],
    () => httpProductTags.listProductTags({ organizationKeyName }),
    { refetchOnWindowFocus: false }
  );
};

export const useDeleteProductTag = () => {
  const queryClient = useQueryClient();

  return useMutation(httpProductTags.deleteProductTag, {
    onSuccess: async () => {
      await queryClient.refetchQueries(productTagsCacheKeys.productTags);
    },
  });
};

export const useUpdateProductTag = () => {
  const queryClient = useQueryClient();

  return useMutation(httpProductTags.updateProductTag, {
    onSuccess: async () => {
      await queryClient.refetchQueries(productTagsCacheKeys.productTags);
    },
  });
};

export const useCreateProductTag = () => {
  const queryClient = useQueryClient();

  return useMutation(httpProductTags.createProductTag, {
    onSuccess: async () => {
      await queryClient.refetchQueries(productTagsCacheKeys.productTags);
    },
  });
};

export const useUpdateProductTagSorting = () => {
  const queryClient = useQueryClient();

  return useMutation(httpProductTags.updateProductTagsSorting, {
    onSuccess: async () => {
      await queryClient.refetchQueries(productTagsCacheKeys.productTags);
    },
  });
};
